import { Injectable } from '@angular/core';
import { ContractRepositoryUserRegisterOutput } from '../4.repository/4.2.contract/contract.user.register/contract.repository.user.register';
import { RepositoryUserRegister } from '../4.repository/repository.user.register';
import { UserDataInteractorInputContract, UserDataInteractorOutputContract } from '../1.contracts/user.data.contract';
import { ContractRepositoryScheduleSettingOutput } from '../4.repository/4.2.contract/contract.schedule.setting/contract.repository.schedule.setting';
import { RepositoryScheduleSetting } from '../4.repository/repository.schedule.setting';
import { EntityScheduleSetting } from '../5.transversal/5.1.entity/entity.schedule.setting';
import { EntityDataToCall } from '../5.transversal/5.1.entity/entity.data.to.call';

@Injectable({
    providedIn: 'root'
})
export class UserDataInteractor implements
    UserDataInteractorInputContract,
    ContractRepositoryUserRegisterOutput,
    ContractRepositoryScheduleSettingOutput
{

    constructor(
        private repoUserRegister: RepositoryUserRegister,
        private repoScheduleSetting: RepositoryScheduleSetting
    ){
        this.repoUserRegister.repoUserRegisterOutput = this;
        this.repoScheduleSetting.repoSecheduleSettingListOutput = this;
    }

    interactorOutput?: UserDataInteractorOutputContract;

    getScheduleSettingList(day: number, month: number, year: number, dayOfWeek: number, plan: number): void {
        this.repoScheduleSetting.repoGetSecheduleSettingList(day, month, year, dayOfWeek, plan);
    }

    sendUserData(
        dataToCall: EntityDataToCall
    ): void {
        this.repoUserRegister.repoUserRegister(
            dataToCall.name,
            dataToCall.cellphone,
            dataToCall.email,
            dataToCall.params,
            dataToCall.timeToCall,
            dataToCall.callMeNow
        );
    }

    repoSecheduleSettingSuccessfulOutput(data: EntityScheduleSetting): void {
        this.interactorOutput?.scheduleSettingListSuccessfulOutput(data);
    }

    repoSecheduleSettingFailureOutput(): void {
        this.interactorOutput?.scheduleSettingListFailureOutput();
    }

    repoRegisterUserSuccessfulOutput(): void {
        this.interactorOutput?.sendUserDataSuccessfulOutput();
    }

    repoRegisterUserFailureOutput(): void {
        this.interactorOutput?.sendUserDataFailureOutput();
    }

}